import { Statistics, TopBar } from 'components/organisms';
import { TopbarPage } from 'components/templates';
import { t } from 'i18next';

const SpotifyStatistics = () => {
  return (
    <TopbarPage topbar={<TopBar title={`${t('statistics.header')}`} customBackItem={<div />} />}>
      <Statistics.SpotifyStatistics />
    </TopbarPage>
  );
};

export default SpotifyStatistics;
